import { useGetFormByIdQuery } from "./features/api/apiSlice";
import { Alert, CircularProgress } from "@mui/material";
import { Form } from "./features/form/Form";
import { EmailConfirmation } from "./features/emailConfirmation/EmailConfirmation";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

interface AppProps {
    formId: string
}

const getToken = () => {
    const parts = window.location.hash.split('?', 2);
    if (parts.length > 1) {
        // TODO: Remove token from URL
        return new URLSearchParams(parts[1]).get('token')
    }
}
const token = getToken()

const getSalesPersonKey = () => {
    const parts = window.location.hash.split('?', 2);
    const salesPersonKey = parts.length > 1 ? new URLSearchParams(parts[1]).get('sp') : null
    if (salesPersonKey !== null) {
        localStorage.setItem('leads-frontend-sp', salesPersonKey.toLowerCase());
        return salesPersonKey.toLowerCase()
    }
    return localStorage.getItem('leads-frontend-sp');
}
const salesPersonKey = getSalesPersonKey()

const App = ({formId}: AppProps) => {
    const {data: form, error: formError} = useGetFormByIdQuery(formId);

    return <LocalizationProvider dateAdapter={AdapterDayjs}>
        {!form
            ? (formError ? <Alert severity="error">Sorry, we could not load the form.</Alert> : <CircularProgress/>)
            : (token ? <Form form={form} token={token}/> : <EmailConfirmation form={form} salesPersonKey={salesPersonKey}/>)
        }
    </LocalizationProvider>
}

export default App
